import React, { useEffect, useState, memo } from 'react';
import RiskByService from './RiskByService';
import DataSourceRiskProfile from './DataSourceRiskProfile';
import UnknownSources from './UnknownSources';
import ResourcePortsPage from './Home/ResourcePortsPage';
import Home from './Home';
import { Alert, Row, Col, Container } from 'react-bootstrap';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const SensitiveDataLandscape = ({ landscapeData, unscannedSources }) => {
  const [fetchingData, setFetchingData] = useState(false);
  const [error, setError] = useState('');
  const { path } = useRouteMatch();

  useEffect(() => {
    setFetchingData(false);
  }, []);

  return (
    <div className='p-0'>
      <Container className='h-100' fluid>
          { error && (
            <Row>
              <Col className='title-div'>
                <Alert variant='danger'>
                  { error }
                </Alert>
              </Col>
            </Row>
          )}

          <Row>
            <Col className='p-0'>
            <Switch>
              <Route exact path={`${path}`}>
                <Home
                  error={error}
                  fetchingData={fetchingData}
                  landscapeData={landscapeData}
                  unscannedSources={unscannedSources}
                />
              </Route>
              {/* Must precede the `:source` catch-all so /landscape/ports/... never
                  routes to RiskByService. */}
              <Route exact path={`${path}/ports/:identifier`}>
                <ResourcePortsPage />
              </Route>
              <Route exact path={`${path}/:source`}>
                <RiskByService
                  error={error}
                  fetchingData={fetchingData}
                  landscapeData={landscapeData}
                  pageSize={10}
                />
              </Route>
              <Route exact path={`${path}/:region/undiscovered`}>
                <UnknownSources
                  unscannedSources={unscannedSources}
                  fetchingData={fetchingData}
                />
              </Route>
              <Route exact path={`${path}/riskprofile/:id`}>
                <DataSourceRiskProfile
                  error={error}
                  fetchingData={fetchingData}
                  pageSize={10}
                />
              </Route>
            </Switch>
            </Col>
          </Row>
      </Container>
    </div>
  );
}

export default SensitiveDataLandscape;